import {
  Row,
  Skeleton,
  Typography,
  VertBreadcrumb,
  VertContainer,
  VertIcon,
  message,
} from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import { SpotInfos } from './components/spotInfos';
import { SpotSupplierInfo } from './components/spotSupplierInfo';
import { SpotHistory } from './components/spotHistory';

import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import SpotOrcament from './components/spotOrcament';
import SpotTerms from './components/spotTerms';
import {
  loadDataSpot,
  loadRedemptionCategories,
  loadUserInfos,
} from 'redux/Reducers/Spot/spotAproveRedemption';
import ModalCancel from './components/VertModalCancel';
import ModalApprove from './components/VertModalAprove';
import ModalCotacao from './components/VertModalCotacao';
import ModalSendDocument from './components/ModalSendDocument';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import VertModalReOpen from './components/VertModalReOpen';
import { RightOutlined } from '@ant-design/icons';
import { SpotNotFound } from 'components/Spot/SpotNotFound';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import generateUUID from 'Utils/generateUUID';

const ViewRedemptionAprovePage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const {callApi} = usePipeContext()
  const [quote, setQuote] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleModalDocument, setIsVisibleModalDocument] = useState(false);
  const [isVisibleCotacao, setIsVisibleCotacao] = useState(false);
  const [loadingHasPermission, setLoadinHasPermission] = useState(true);

  const dispatch = useDispatch();
  const [productsIds, setProductsIds] = useState([]);
  const [isVisibleModalCancel, setIsVisibleModalCancel] = useState(false);
  const [error, setError] = useState(false);
  const [typeReOpen, setTypeReOpen] = useState(false);
  const [isVisibleModalAprovePMO, setIsVisibleModalAprovePMO] = useState(false);
  const [termDownloadUrl, setTermDownloadUrl] = useState(null);
  const { isPMO, isManager, isLead, getRedemptionSpotGroups } =
    useParticipantSubSegment();
  const validGroup = getRedemptionSpotGroups();

  const [modalDocument, setModalDocument] = useState({
    type: 1,
    url: null,
  });

  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const participantId = userProfile['custom:participant_id'];

  useEffect(() => {
    if (userInfos?.isLoaded) {
      dispatch(
        loadDataSpot({
          redemptionId: params.id,
          headers: config,
        })
      );
    }
  }, [userInfos]);

  const {
    dataSpot: spot,
    quote: customQuote,
    termUrl,
    isErrorSpot,
    isLoadingSpot: isLoadingSpotReducer,
  } = useSelector((state) => state.SpotAproveRedemption);
  const isLeaderShipConfirmSpotHierarchy = isLead && spot?.redemptionStatusId === 10;



  useEffect(() => {
    setIsLoading(isLoadingSpotReducer);
  }, [isLoadingSpotReducer]);

  useEffect(() => {
    let _quote = customQuote;
    if (
      spot?.redemptionStatusId > 2 &&
      spot?.redemptionStatusId !== 5 &&
      spot?.type !== 4
    ) {
      _quote = spot?.files.find((x) => x.approved === true);
    }

    setQuote(_quote);
  }, [spot]);

  useEffect(() => {
    if (!spot) {
      setLoadinHasPermission(false);
      return;
    }

    if (spot.participantId && participantId) {
      const isAccessParticipant = String(spot.participantId) === participantId;

      const hasAccess = isPMO || isLead || isManager || isAccessParticipant;

      if (!hasAccess) {
        setError(true);
      } else {
        setLoadinHasPermission(true);
      }
    }
  }, [spot, isPMO, isLead, isManager, spot?.participantId, participantId]);

  useEffect(() => {
    if (spot !== null) {
      handleSetTermDownloadUrl(spot);

      dispatch(loadRedemptionCategories())
      if (
        spot.redemptionStatusId === 3 ||
        (spot.type === 3 && spot.redemptionStatusId === 4)
      ) {
        dispatch(
          loadUserInfos({
            participantId: spot?.participantId,
            headers: config,
          })
        );
      }
    }
  }, [spot]);

  const handleSetTermDownloadUrl = (spot) => {
    if ((spot.redemptionStatusId === 4) || isLeaderShipConfirmSpotHierarchy) {
      const { url } = spot.files.find((f) => f.type === 2 && f.status === 1);
      setTermDownloadUrl(url);
    }
  };

  const callModalDocuments = (type, document) => {
    setModalDocument({ type, url: document });
    setIsVisibleModalDocument(true);
  };

  const callModalButton = (action) => {
    if (action === 'approve') {
      setIsVisibleModalAprovePMO(true);
    } else if (action === 'cotacao') {
      setIsVisibleCotacao(true);
    } else if (action === 'reopen') {
      setTypeReOpen(true);
    } else {
      setIsVisibleModalCancel(true);
    }
  };

  const cancelSpot = (payloadModal) => {
    const { description } = payloadModal;

    setIsVisibleModalCancel(false);
    setIsLoading(true);
    const data = {
      redemptionId: params.id,
      description,
    };
    redemptionsApiClient
      .put(`/Redemption/Refuse`, data, {
        headers: config,
      })
      .then((res) => {
        navigate('/list-redemptions', {
          state: {
            spotCanceled: true,
            spotId: params.id,
          },
        });
      })
      .catch((err) => {
        message.error(
          'Não foi possível cancelar esta solicitação, valide as informações e tente novamente.'
        );
        setIsLoading(false);
      });
  };

  const reopenSpot = (payloadModal) => {
    const { description } = payloadModal;
    setIsVisibleCotacao(false);
    setIsLoading(true);
    const data = {
      redemptionId: params.id,
      description: description,
    };

    let url =
      spot.redemptionStatusId === 2
        ? '/Redemption/ReturnToOperation'
        : `/Redemption/Reopen`;

    redemptionsApiClient
      .put(url, data, {
        headers: config,
      })
      .then((res) => {
        navigate('/list-redemptions?redemptionSuccess=true', {
          state: {
            spotToQuote: spot.redemptionStatusId === 2,
            spotReopen: spot.redemptionStatusId !== 2,
            spotId: params.id,
          },
        });
      })
      .catch((err) => {
        message.error(
          'Não foi possível reabrir esta solicitação, valide as informações e tente novamente.'
        );
        setIsLoading(false);
      });
  };

  const approveSpot = (payloadModal) => {
    const { description } = payloadModal;

    setIsVisibleModalAprovePMO(false);

    if (productsIds.length === 0) {
      message.error(
        'É necessário selecionar ao menos um orçamento e um produto, valide as informações e tente novamente.'
      );
      return;
    }

    setIsLoading(true);

    let data = null;
    if (spot.redemptionStatusId === 2) {
      // PMO
      data = {
        redemptionId: params.id,
        description,
        status: 3,
        quoteId: quote.id,
        productsIds: productsIds.filter((v, i, a) => a.indexOf(v) === i),
        termUrl: null,
      };
    }

    if (spot.redemptionStatusId === 4) {
      const noTerm = (termUrl === null || !termUrl.length) && isPMO;

      // PMO or Participant
      if (noTerm && spot.type !== 4) {
        message.error(
          'Não foi possível aprovar a solicitação, valide as informações e tente novamente.'
        );
        setIsLoading(false);
        return;
      }
      data = {
        redemptionId: params.id,
        description,
        status: String(spot.participantId) === participantId ? 6 : 10,
      };

      data = spot.type !== 4 ? { ...data, termUrl } : data;
      data = spot.type === 4 ? { ...data, quoteId: quote.id } : data;
    }

    if (isLeaderShipConfirmSpotHierarchy) {
      data = {
        redemptionId: params.id,
        description,
        status: 6,
        termUrl: termDownloadUrl,
      };
    }

    const url =
      spot.type === 4 ? `/Redemption/Approve/Quote` : `/Redemption/Approve`;



    const result = redemptionsApiClient.put(url, data, {
      headers: config,
    });

    result.then((res) => {
      console.log('res', res);
      callApi({
        symbol: 'LOAD_BALANCE',
        alias: generateUUID(),
      })
      if (res.status === 204) {
        message.success('Solicitação aprovada com sucesso!');
      
        navigate('/list-redemptions?redemptionSuccess=true', {
          state: {
            spotApproved: true,
            spotId: params.id,
          },
        });
      setIsLoading(false);
        return;
      } else if (
        (spot.type === 1 || spot.type === 2 || spot.type === 4) &&
        res?.data !== null &&
        res?.data.failed.length > 0
      ) {
        message.error(
          'Não foi possível aprovar a solicitação, valide as informações e tente novamente.'
        );
        setIsLoading(false);
        return false;
      }

      if (
        spot.type === 3 &&
        res?.data !== null &&
        res?.data.failed.length > 0
      ) {
        message.error(
          'Um ou mais produtos não foram aprovados. Entre em contato com o responsável.'
        );
        setIsLoading(false);
        return false;
      }
      navigate('/list-redemptions?redemptionSuccess=true', {
        state: {
          spotApproved: true,
          spotId: params.id,
        },
      });
    })
      .catch((err) => {
        if (
          err.response?.data.code === 400001 ||
          err.response?.data.code === '400001'
        ) {
          message.error('O saldo atual é inferior ao valor do produto.');
        } else {
          message.error(
            'Não foi possível aprovar a solicitação, valide as informações e tente novamente.'
          );
        }

        setIsLoading(false);
      });
  };

  const getSpotTypeDescription = () => {
    if ((isPMO || isLead) && spot && spot.type === 2) return 'SPOT HIERARQUIA';

    if (spot && spot.type === 4) return 'COTAÇÃO DIRETA';

    return 'SPOT';
  };

  const breadcrumbMock = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Lista de Solicitações',
      path: '/list-redemptions',
    },
    {
      title: `Solicitação #${params.id} - ${getSpotTypeDescription()}`,
      path: `/approve-redemption/${params.id}`,
    },
  ];
  return (
    <>
      <VertContainer spacingX="regular" spacingY="small">
        <Row className="extract-page-breadcrumb" align="middle" gutter={0}>
          <VertBreadcrumb hasBackButton={true}
            separator={<VertIcon component={RightOutlined} />}
            items={breadcrumbMock}
          />
        </Row>
      </VertContainer>

      {error || isErrorSpot ? (
        <SpotNotFound id={params.id} />
      ) : (
        <VertContainer fluid>
          {!spot || !spot.id || !loadingHasPermission  ? (
            <VertContainer spacingX="regular" spacingY="small">
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </VertContainer>
          ) : (
            <VertContainer>
            
              <div className={'container-view-redemption'}>
                <VertContainer className="container-title-view-redemption">
                  <Typography.Text className="title-view-redemption">
                    Solicitação #{spot.id} - {getSpotTypeDescription()}
                  </Typography.Text>
                </VertContainer>
                <SpotInfos
                  spot={spot}
                  isManager={isPMO || isLead}
                  callModalDocuments={callModalDocuments}
                />
                <SpotSupplierInfo
                  spot={spot}
                  callModalDocuments={callModalDocuments}
                />

                <SpotHistory
                  histories={spot.histories}
                  isManager={isPMO || isLead}
                />

                {
                  spot && spot?.products?.length && (

                    <SpotOrcament
                    spot={spot}
                    quote={quote}
                    setQuote={setQuote}
                    callModalDocuments={callModalDocuments}
                    isPMO={isPMO}
                    isLead={isLead}
                    productsIds={productsIds}
                    setProductsIds={setProductsIds}
                  />



                  )
                }

              

                <SpotTerms
                  spot={spot}
                  callModalDocuments={callModalDocuments}
                  isLoading={isLoading}
                  isPMO={isPMO}
                  participantId={participantId}
                  callModal={callModalButton}
                  isLead={isLead}
                  quote={quote}
                  productsIds={productsIds}
                  termDownloadUrl={termDownloadUrl}
                />
              </div>
            </VertContainer>
          )}

          <ModalCancel
            isVisible={isVisibleModalCancel}
            setIsVisible={setIsVisibleModalCancel}
            spot={spot}
            isPMO={isPMO}
            isLead={isLead}
            submitCancel={cancelSpot}
          />
          <ModalApprove
            spot={spot}
            isPMO={isPMO}
            isLead={isLead}
            isVisible={isVisibleModalAprovePMO}
            setIsVisible={setIsVisibleModalAprovePMO}
            submitApprove={approveSpot}
          />
          <ModalCotacao
            submitApprove={reopenSpot}
            isVisible={isVisibleCotacao}
            setIsVisible={setIsVisibleCotacao}
            spot={spot}
            isPMO={isPMO}
            isLead={isLead}
            modalDocument={modalDocument}
          />
          <VertModalReOpen
            submitApprove={reopenSpot}
            isVisible={typeReOpen}
            setIsVisible={setTypeReOpen}
            spot={spot}
            isPMO={isPMO}
            isLead={isLead}
            modalDocument={modalDocument}
          />
          <ModalSendDocument
            isVisible={isVisibleModalDocument}
            setIsVisible={setIsVisibleModalDocument}
            spot={spot}
            document={modalDocument}
            isPMO={isPMO}
            isLead={isLead}
            modalDocument={modalDocument}
          />
        </VertContainer>
      )}
    </>
  );
};

export default ViewRedemptionAprovePage;
